// AWIN affiliate tracking. tracking-snippet.liquid passes the theme settings as data-* attributes.
window.AWIN = window.AWIN || {};
window.AWIN.Tracking = window.AWIN.Tracking || {};

(({advertiserId, priorityPublishers = ''}) => {
  // AWIN MasterTag after window load, when idle. The awc/publisher cookies below are still set right
  // away from the landing URL, so affiliate attribution doesn't depend on it.
  window.pgxAfterLoad(() => {
    const s = document.createElement('script');
    s.src = `https://www.dwin1.com/${advertiserId}.js`;
    document.body.appendChild(s);
  });

  const ALL_PUBLISHERS = priorityPublishers
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  const urlParams = new URLSearchParams(window.location.search);
  const awc = urlParams.get('awc');
  const publisherId = urlParams.get('sv_campaign_id');
  const sn = urlParams.get('sn');

  if (!awc || !publisherId) return;

  const existingCookie = document.cookie.split('; ').find((row) => row.startsWith('awc='));
  const existingPublisherCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('publisher_id='));

  const existingPublisherId = existingPublisherCookie
    ? existingPublisherCookie.split('=')[1]
    : null;

  const isNewPriority = ALL_PUBLISHERS.includes(publisherId) && sn === '1';
  const isExistingPriority = ALL_PUBLISHERS.includes(existingPublisherId);

  const setCookies = (awcValue, pubId) => {
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `awc=${awcValue}; path=/; max-age=${maxAge}; secure; samesite=lax`;
    document.cookie = `publisher_id=${pubId}; path=/; max-age=${maxAge}; secure; samesite=lax`;
  };

  if (isExistingPriority) return;

  if (isNewPriority) {
    setCookies(awc, publisherId);
    return;
  }

  if (!existingCookie) {
    setCookies(awc, publisherId);
  }
})(document.currentScript.dataset);
